import ParticleBackground from "../components/ParticleBackground";
import { Card } from "../components/ui/card";
import "../styles/home.css";
import "../styles/premium-enhancements.css";

const PrivacyPolicy = () => {
  return (
    <div className="home-container">
      <ParticleBackground />
      <div className="aurora-bg"></div>

      <section
        className="services-section"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Card
  className="glass-card-premium neon-border fade-in-up"
  style={{
    maxWidth: "900px",
    margin: "0 auto",
    padding: "50px",
  }}
>

          <h1 className="section-title" style={{ textAlign: "center" }}>
            Privacy <span className="gradient-text">Policy</span>
          </h1>

          <p
            className="section-subtitle"
            style={{ textAlign: "center", marginBottom: "40px" }}
          >
            Your privacy matters to us at aiwebAA
          </p>

          <div className="privacy-content">
            <h3>Information We Collect</h3>
            <p>
              We collect information such as name, email address, and project
              details when you submit forms on our website.
            </p>

            <h3>How We Use Your Information</h3>
            <p>
              Your information is used to communicate with you, provide our
              services, and improve our platform.
            </p>

            <h3>Data Protection</h3>
            <p>
              We use industry-standard security practices to protect your data
              from unauthorized access or misuse.
            </p>

            <h3>Third-Party Services</h3>
            <p>
              We may use trusted third-party tools for analytics, automation,
              and form handling. These services follow their own privacy
              policies.
            </p>

            <h3>Policy Updates</h3>
            <p>
              This Privacy Policy may be updated from time to time. Updates will
              always be reflected on this page.
            </p>

            <h3>Contact</h3>
            <p>
              If you have questions about this policy, contact us at
              <strong> hello@aiwebaa.com</strong>
            </p>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
